import { Put } from '../helpers';

export type ModifyProjectGroupsForAdminProps = {
  channel: number;
  email: string;
  groupsToDelete: string[];
  groupsToAdd: string[];
};

const ModifyProjectGroupsForAdmin = (
  params: ModifyProjectGroupsForAdminProps
): Promise<ModifyProjectGroupsForAdminProps & { added: string[]; deleted: string[]; adminId: number }> => {
  return Put({
    path: `/v3/admin/channel/${params.channel}/event-groups/admin`,
    body: params,
  });
};

export default ModifyProjectGroupsForAdmin;
